import { useEffect } from 'react';
import useServerStateContext from '@/shared/hooks/useServerStateContext';

export const useCameraSelectionBindings = (onCameraSelectionChange: (cameraId: number) => void) => {
    const { availableCameras } = useServerStateContext();

    useEffect(() => {
        if (availableCameras && availableCameras.length > 0) {
            const cameras = availableCameras;
            if (!cameras) {
                return;
            }

            const handleKeyDown = (e: KeyboardEvent) => {
                // Ignore if user is typing in an input field, textarea, or contenteditable element
                const target = e.target as HTMLElement;
                const tagName = target.tagName;
                const isFormElement = tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT';
                const isContentEditable = target.isContentEditable;

                if (isFormElement || isContentEditable) {
                    return; // Don't trigger camera selection when typing
                }

                const key = parseInt(e.key, 10);
                if (key >= 1 && key <= 9) {
                    const camera = cameras[key - 1];
                    if (camera) {
                        e.preventDefault();
                        onCameraSelectionChange(camera.camIndex);
                    }
                }
            };

            window.addEventListener('keydown', handleKeyDown);
            return () => {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [availableCameras, onCameraSelectionChange]);
};

export default useCameraSelectionBindings;